import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const useGuestGuard = () => {
  const access_token = useSelector((state) => state.auth.access_token);
  const history = useHistory();

  useEffect(() => {
    if (access_token) {
      // Redirect to homepage
      history.replace({
        pathname: "/",
      });
    }
  }, [access_token, history]);
};

export default useGuestGuard;
